import { useEffect } from 'react'

const useFakeBackNavigationListener = callback => {
  useEffect(() => {
    // Add a fake history event so that the back button does nothing if pressed once
    window.history.pushState('fake-route', document.title, window.location.href)
    window.addEventListener('popstate', callback)

    // cleanup on unmount
    return () => {
      window.removeEventListener('popstate', callback)
      if (window.history.state === 'fake-route') {
        window.history.back()
      }
    }
  }, [])
}

export default useFakeBackNavigationListener
